module.exports = __webpack_public_path__ + "img/ci.8d841792.svg";